import { useProfile } from '@/modules/profile';
import {
  CONTRACTOR_TYPE_PHARMACY,
  CONTRACTOR_TYPE_PHARMACY_OFFICE,
  CONTRACTOR_TYPE_PHARMACY_WAREHOUSE,
} from '@/shared/constants/contractor-types.constants';

const PHARMACY_ALIASES = [
  CONTRACTOR_TYPE_PHARMACY_OFFICE,
  CONTRACTOR_TYPE_PHARMACY_WAREHOUSE,
  CONTRACTOR_TYPE_PHARMACY,
];

export const useIsPharmacy = () => {
  const { contractor } = useProfile();

  return PHARMACY_ALIASES.includes(contractor?.contractor_type?.alias as string);
};
